<template>
  <v-dialog
    :value="value"
    max-width="1100px"
    persistent
    scrollable
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title class="d-flex flex-wrap align-center">
        <span class="headline mr-2">ຈັດການ Permission ຂອງ Role</span>
        <v-chip
          label
          color="primary"
          class="mr-2"
        >
          {{ role.name }}
        </v-chip>
        <span class="body-2 grey--text">
          ເລືອກແລ້ວ {{ selected.length }} / {{ allNames.length }}
        </span>
        <v-spacer />
        <v-text-field
          v-model="search"
          clearable
          dense
          hide-details
          prepend-inner-icon="mdi-magnify"
          label="ຄົ້ນຫາ permission"
          style="max-width: 280px"
        />
      </v-card-title>

      <v-alert
        v-if="customerRole"
        type="warning"
        dense
        text
        class="mx-4 mb-0"
      >
        Role ຂອງລູກຄ້າ (pre_customer, customer, company) ປ່ຽນ permission ບໍ່ໄດ້.
      </v-alert>

      <v-divider />
      <v-card-text style="height: 65vh">
        <v-row
          v-if="loadingPermissions"
          justify="center"
          class="my-8"
        >
          <v-progress-circular
            indeterminate
            color="primary"
          />
        </v-row>
        <PermissionGroupPicker
          v-else
          v-model="selected"
          :names="allNames"
          :original="original"
          :search="search || ''"
          :disabled="customerRole"
        />
      </v-card-text>
      <v-divider />

      <v-card-actions>
        <span class="body-2">
          <span class="success--text mr-3">+ ເພີ່ມ {{ added.length }}</span>
          <span class="error--text">− ຖອນ {{ removed.length }}</span>
        </span>
        <v-spacer />
        <v-btn
          text
          :disabled="saving"
          @click="close"
        >
          ຍົກເລີກ
        </v-btn>
        <v-btn
          color="primary"
          :loading="saving"
          :disabled="saving || customerRole || (!added.length && !removed.length)"
          @click="save"
        >
          ບັນທຶກ
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PermissionGroupPicker from './PermissionGroupPicker.vue';
import { CUSTOMER_ROLES } from './permissionCatalog';

export default {
  name: 'RolePermissionEditor',
  components: { PermissionGroupPicker },
  props: {
    value: { type: Boolean, default: false },
    role: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      allNames: [],
      original: [],
      selected: [],
      search: '',
      loadingPermissions: false,
      saving: false,
    };
  },
  computed: {
    customerRole() {
      return CUSTOMER_ROLES.includes(this.role.name);
    },
    added() {
      return this.selected.filter((name) => !this.original.includes(name));
    },
    removed() {
      return this.original.filter((name) => !this.selected.includes(name));
    },
  },
  watch: {
    value(open) {
      if (open) this.load();
    },
  },
  methods: {
    load() {
      this.search = '';
      this.original = (this.role.permissions || []).map((permission) => permission.name);
      this.selected = [...this.original];
      this.loadingPermissions = true;
      this.$axios
        .get('user-setting/permission')
        .then((res) => {
          this.allNames = (res.data.data || []).map((permission) => permission.name);
        })
        .catch((error) => this.toast('error', this.message(error)))
        .finally(() => {
          this.loadingPermissions = false;
        });
    },
    async save() {
      this.saving = true;
      try {
        // give-permission REPLACES the role's permissions (syncPermissions), so it gets the
        // whole selected list, not only the added ones; one request also saves atomically.
        // An empty list is refused by the request validation, so clearing every permission
        // goes through revoke instead.
        if (this.selected.length) {
          await this.$axios.post(`user-setting/role/${this.role.id}/give-permission`, { permissions: this.selected });
        } else if (this.removed.length) {
          await this.$axios.post(`user-setting/role/${this.role.id}/revoke-permission`, { permissions: this.removed });
        }
        this.toast('success', `ບັນທຶກແລ້ວ: ເພີ່ມ ${this.added.length}, ຖອນ ${this.removed.length}`);
      } catch (error) {
        // The parent reloads the server's state, and the editor closes so it is reopened on that state.
        this.toast('error', this.message(error));
      } finally {
        this.saving = false;
        this.$emit('saved');
        this.$emit('input', false);
      }
    },
    close() {
      this.$emit('input', false);
    },
    message(error) {
      return (error.response && error.response.data && error.response.data.message) || 'Something went wrong';
    },
    toast(color, msg) {
      this.$store.commit('Toast_State', { value: true, color, msg });
    },
  },
};
</script>
